import React from "react";
import FooterLinkBar from "./FooterLinkBar";
import BottomBar from "./BottomBar";

const Footer = () => {
  return (
    <>
      <FooterLinkBar />
      <BottomBar />
    </>
  );
};

export default Footer;
